<template>
    <div>
        <h6 class="text-uppercase bg-light"> Permissions </h6>
        <b-form-checkbox
            v-for="permission in ALL_PERMISSIONS"
            :key="permission"
            v-model="permissions[permission]"
            class="ml-2"
            switch
            :disabled="disabled"
            @input="emitValue"
        >
            {{ permission | startCase }}
        </b-form-checkbox>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    props: {
        value: {
            type: Object,
            required: true
        },

        disabled: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    data() {
        return {
            permissions: {}
        };
    },

    computed: {
        ...mapGetters({
            ALL_PERMISSIONS: 'acls/PERMISSIONS'
        })
    },

    created() {
        this.permissions = { ...this.value };
    },

    methods: {
        emitValue() {
            this.$emit('input', this.permissions);
        }
    }
};
</script>
